import { formatDateString } from '@/utils/constants';

export const columns = [
	{
		field: 'Description',
		headerName: 'Description',
		flex: 1.4,
	},
	{
		field: 'PolicyNumber',
		headerName: 'Policy number',
		flex: 1,
	},
	{
		field: 'ClassOfRisk',
		headerName: 'Class of risk',
		flex: 1,
	},
	{
		field: 'InsurerName',
		headerName: 'Insurer',
		flex: 1,
	},
	{
		field: 'ToDate',
		headerName: 'Renewal date',
		flex: 1,
		valueGetter: (value) => formatDateString(value),
	},
];
